import { useCallback, useMemo } from "react";
import { useGlobalEditingState } from "modules/providers/global-editing-state-provider";

const useGlobalEditing = (componentEditingId: string) => {
  const { mode, setMode, editingId } = useGlobalEditingState();

  const _mode = useMemo(() => {
    if (editingId === componentEditingId) {
      return mode;
    }
    return "display";
  }, [componentEditingId, editingId, mode]);

  const _setMode = useCallback(
    (newMode: "display" | "edit") => () => {
      setMode(componentEditingId, newMode);
    },
    [componentEditingId, setMode],
  );

  return {
    mode: _mode,
    setMode: _setMode,
  };
};

export default useGlobalEditing;
